import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'tenderingTextYear'
})
export class TenderingTextYearPipe implements PipeTransform {
  /**
   *
   */
  constructor(private translate: TranslateService) {

  }
  transform(value: string): any {
    if (value == null) {
      return ''; // Varsayılan değer
    }
    const horseYear = value.match(/\d+/)[0];
    return horseYear;
  }
}
